export default __webpack_public_path__ + "static/media/icon-chat-blue.b9a1347c.svg";